import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { FuelInsightsRequest, FuelKpiRequest } from '../../_shared';
import { Response } from '../../../_shared/models';
import { FuelKpiSummaryResponse } from '../../_shared/models/fuel-kpi-response.model';
import { FuelInsightsResponse } from '../../_shared/models/fuel-insights-response.model';

@Injectable({
  providedIn: 'root'
})
export class ReconciliationVariateService {

  constructor(private http: HttpClient) { }

  public getReconciliationVariateSummary(request: FuelKpiRequest, cancellation: Subject<void>): Promise<Response<FuelKpiSummaryResponse>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/fuelDashboard/reconciliation-variate-summary`, request).pipe(takeUntil(cancellation)));
  }

  public getFuelDetectedInsights(request: FuelInsightsRequest, cancellation: Subject<void>): Promise<Response<FuelInsightsResponse>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/fuelDashboardinsights/recon-variant/fuel-detected-insights`, request).pipe(takeUntil(cancellation)))
  }

  public getFuelBoughtInsights(request: FuelInsightsRequest, cancellation: Subject<void>): Promise<Response<FuelInsightsResponse>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/fuelDashboardinsights/recon-variant/fuel-bought-insights`, request).pipe(takeUntil(cancellation)))
  }

  public getFuelBoughtCostInsights(request: FuelInsightsRequest, cancellation: Subject<void>): Promise<Response<FuelInsightsResponse>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/fuelDashboardinsights/recon-variant/fuel-bought-cost-insights`, request).pipe(takeUntil(cancellation)))
  }

  public getFuelDetectedCostInsights(request: FuelInsightsRequest, cancellation: Subject<void>): Promise<Response<FuelInsightsResponse>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/fuelDashboardinsights/recon-variant/fuel-detected-cost-insights`, request).pipe(takeUntil(cancellation)))
  }
}